var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {
        $('.vimeo-button').on('click', function() {
            var playerId = $(this).siblings('.vimeo-video').attr('id');
        
            var player = document.getElementById(playerId);
            var data = { method: "play" };
            player.contentWindow.postMessage(JSON.stringify(data), "*");
            
            $(this).hide();
            $(this).closest('.video-wrap').addClass('interacted');
            $(this).closest('.video-wrap').removeClass('loading');
        });
    });
});
